import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ENotificationsActionTypes } from './types';

export const updateNotificationsCount = actionGenerator<ENotificationsActionTypes.UpdateCount, number>(
  ENotificationsActionTypes.UpdateCount,
);
